import './App.css';
import { Routes, Route } from 'react-router-dom';
import Navbar from './Components/Navbar'
import About from './Pages/About'
import Help from './Pages/Help'
import COTPage from './Pages/COT'
import COT from './Pages/COT/index'
import COTLegacyFutures from './Pages/COTLegacyFutures'
import COTFutures from './Pages/COTFutures'
import Home from './Pages/Home'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../node_modules/bootstrap/dist/js/bootstrap.bundle'
import Footer from './Components/Footer';
import COTLegacyindex from './Pages/COTLegacy/index';
import ScrollToTop from './Components/ScrollToTop'

function App() {
  return (
    <div className="App">
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/cot" element={<COTPage />} />
        <Route exact path="/cot/futures/fin/:id" element={<COT />} />
        <Route exact path="/cot/futures" element={<COTFutures />} />
        <Route exact path="/cot/legacy-futures" element={<COTLegacyFutures />} />
        <Route exact path="/cot/legacy-futures/:id" element={<COTLegacyindex />} />
        <Route exact path="/help" element={<Help />} />
        <Route exact path="/about" element={<About />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
